import styled from 'styled-components';

export const Image = styled.div`
  display: flex;
  justify-content: center;
  img{
    height: 120px;
  }

  margin: 10px auto 0;
`;

export const List = styled.div`
  display: flex;
  justify-content: center;
  background: #F7F5E6;
  padding: 10px;

  ul{
    display: flex;
  }

  li {
    display:flex;
    flex-direction: column;
    align-items: center;
    
    margin-right: 5px;
  }

  input {
    text-align:center;
    font-weight: 600;
    font-size: 12px;

    width: 23px;
    height: 23px;
    border: 1px solid ${({theme}) => theme.palette.secondary.main};
    border-radius: 20%;
  }
`

export const List2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F7F5E6;
  margin: 5px 0 15px;
  padding: 10px 0;
  

  div{
    display: flex;
    margin-bottom: 10px;

    :last-child{
      margin-bottom: 0;
    }
  }

  ul{
    display: flex;
    margin-right: 10px;

    :last-child{
      margin-right: 0;
    }
  }

  li {
    display:flex;
    flex-direction: column;
    align-items: center;

    margin-right: 2px;

    :last-child{
      margin-right: 0;
    }
  }
`